export default __webpack_public_path__ + "static/media/Cobertura-WiFi-1.038f12a1.png";